<template>
    <div v-if="showRetail || showNonProfit || showConsumerService">
        <v-row id="product__rowpadding">
            <v-col :cols="4" class="label-field text-left no-right no-bottom">
                <span id="font_bold">Non-Profit/Consumer Services/Retail</span>
            </v-col>
            <v-col :cols="6" class="text-left no-left no-bottom no-top">
            </v-col>
        </v-row>
        <v-row id="product__rowpadding">
            <v-col :cols="4" class="label-field text-left no-right no-bottom">
                <span id="font_bold" class="italic">Non-Profit/Consumer Services/Retail - Credit</span>
            </v-col>
            <v-col :cols="6" class="text-left no-left no-bottom no-top">
            </v-col>
        </v-row>
        <v-row id="product__rowpadding">
            <v-col :cols="4" class="label-field text-left no-right no-bottom">
                Credit Card Mentioned:
            </v-col>
            <v-col :cols="6" class="text-left no-left no-bottom no-top">
                <v-checkbox v-model="credit_card_mentioned" class="d-inline-block"/>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    name: 'Retail',
    props : [
        "showRetail",
        "showNonProfit",
        "showConsumerService"
    ],
    computed: {
        ...mapGetters({
            sector: 'ProductData/getSector',
        }),
        credit_card_mentioned: {
            get: function() {
                return this.$store.getters['ProductData/getRetailCreditCardMentioned']
            },
            set: function(o) {
                this.$store.dispatch('ProductData/setRetailCreditCardMentioned', o)
            }
        }
    }
}
</script>